import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { orderDb } from '../firebaseOrders';
import AdminOrderCard from './AdminOrderCard';

const cities = [
  'Seattle, WA', 'Cincinnati, OH', 'Dallas, TX', 'Reno, NV',
  'Robbinsville, NJ', 'Jacksonville, FL', 'Minneapolis, MN',
  'Phoenix, AZ', 'Richmond, VA'
];


const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [inventoryData, setInventoryData] = useState({});
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  useEffect(() => {
    const fetchOrders = async () => {
      const ordersSnapshot = await getDocs(collection(orderDb, 'orders'));
      const ordersList = ordersSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setOrders(ordersList);

      // Fetch inventory logic unchanged...
      const inventoryFetches = [];

      ordersList.forEach(order => {
        order.items.forEach(item => {
          const style = item.style;
          const color = item.colorName4API;
          const size = item.size;
          const productId = `${style}-${color}-${size}`;

          if (!inventoryFetches.some(f => f.productId === productId)) {
            inventoryFetches.push(
              fetchInventory(style, color, size).then(cityQuantities => ({
                productId,
                cityQuantities
              }))
            );
          }
        });
      });

      const results = await Promise.all(inventoryFetches);
      const inventoryMap = {};
      results.forEach(({ productId, cityQuantities }) => {
        inventoryMap[productId] = cityQuantities;
      });

      setInventoryData(inventoryMap);
      setLoading(false);
    };

    fetchOrders();
  }, []);

  const fetchInventory = async (style, color, size) => {
      try {
      const fetchAttempt = async () => {
        const response = await fetch('https://api-shipping-28612190fdf4.herokuapp.com/inventory', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ style, color, size }),
        });

        const text = await response.text();
        const xml = new DOMParser().parseFromString(text, 'application/xml');
        const quantities = Array.from(xml.getElementsByTagName('listResponse')).map(item => item.textContent);

        return cities.reduce((acc, city, index) => {
          acc[city] = quantities[index] || 'No Info';
          return acc;
        }, {});
      };

      let cityQuantities = await fetchAttempt();
      if (Object.values(cityQuantities).some(q => q !== 'No Info')) return cityQuantities;

      // Retry once more if no info
      cityQuantities = await fetchAttempt();
      return cityQuantities;
    } catch (error) {
      console.error('Inventory fetch error:', error);
      return cities.reduce((acc, city) => {
        acc[city] = 'No Info';
        return acc;
      }, {});
    }
  
  };

  // Filter orders by search and date range
const filteredOrders = orders.filter(order => {
  let orderDate = order.createdAt?.toDate ? order.createdAt.toDate() : new Date(order.createdAt);
  if (!orderDate || isNaN(orderDate)) return false;

  const from = fromDate ? new Date(fromDate) : null;
  if (from) from.setHours(0, 0, 0, 0);

  const to = toDate ? new Date(toDate) : null;
  if (to) to.setHours(23, 59, 59, 999);

  const inDateRange = (!from || orderDate >= from) && (!to || orderDate <= to);

  const name = order.customerDetails?.name?.toLowerCase() || '';
  const orderNumber = order.orderNumber?.toString() || '';

  return inDateRange && (name.includes(search.toLowerCase()) || orderNumber.includes(search));
});


  const getOrderTotal = (order) => {
    const itemSum = order.items.reduce((sum, item) => {
      const price = parseFloat(item.price || 0);
      return sum + price;
    }, 0);
    return itemSum + parseFloat(order.shippingRate || 0); //+3 shipping
  };
const getOrderTotalShipping = (order) => {
  return parseFloat(order.shippingRate || 0);
};


    const getOrderTotal4GarmentPrice = (order) => {
    const itemSum = order.items.reduce((sum, item) => {
      const price = parseFloat(item.actualGarmentPrice || 0);
      return sum + price;
    }, 0);
    return itemSum ;
  };
  const getOrderTotal4ImagePrice = (order) => {
    const itemSum = order.items.reduce((sum, item) => {
      const price = parseFloat(item.actualImagePrice || 0);
      return sum + price;
    }, 0);
    return itemSum ;
  };
    const getOrderTotal4Others = (order) => {
    const itemSum = order.items.reduce((sum, item) => {
      const price = parseFloat(item.otherCost || 0);
      return sum + price;
    }, 0);
    return itemSum ;
  };

  const grandTotal = filteredOrders.reduce((sum, order) => {
    return sum + getOrderTotal(order);
  }, 0);
    const grandTotal2 = filteredOrders.reduce((sum, order) => {
    return sum + getOrderTotal4GarmentPrice(order);
  }, 0);
    const grandTotal3 = filteredOrders.reduce((sum, order) => {
    return sum + getOrderTotal4ImagePrice(order);
  }, 0);
    const grandTotal4 = filteredOrders.reduce((sum, order) => {
    return sum + getOrderTotal4Others(order);
  }, 0);
      const grandTotal5 = filteredOrders.reduce((sum, order) => {
    return sum + getOrderTotalShipping(order);
  }, 0);
  const Final = grandTotal- (grandTotal2+grandTotal3+grandTotal4+grandTotal5)
  //  const Final = grandTotal5 
  return (
    <div style={{ padding: '1rem' }}>
      <h2>📦 Admin Orders</h2>

      {/* Search input */}
      <input
        type="text"
        placeholder="Search by customer name or order number..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ padding: '0.5rem', marginBottom: '1rem', width: '100%', maxWidth: 400 }}
      />

      {/* Date filters */}
      <div style={{ marginBottom: '1rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <label>
          From:{' '}
          <input
            type="date"
            value={fromDate}
            onChange={e => setFromDate(e.target.value)}
          />
        </label>
        <label>
          To:{' '}
          <input
            type="date"
            value={toDate}
            onChange={e => setToDate(e.target.value)}
          />
        </label>
      </div>

      {/* Grand total */}
      <div style={{
        marginBottom: '2rem',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: '#222'
      }}>
        Total Across All Filtered Orders: ${grandTotal.toFixed(2)}
        <div>Total Garment costs Across All Filtered Orders: ${grandTotal2.toFixed(2)}</div>
<div>Total DTF costs Across All Filtered Orders: ${grandTotal3.toFixed(2)}</div>
<div>Total other costs: ${grandTotal4.toFixed(2)}</div>
<div>Total Gain/Loss: ${Final.toFixed(2)}</div>
      </div>

      {/* Orders list */}
      {loading ? (
        <p>Loading orders and inventory...</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {filteredOrders.map(order => (
            <AdminOrderCard
              key={order.id}
              order={order}
              inventoryData={inventoryData}
              orderTotal={getOrderTotal(order).toFixed(2)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminOrders;



// import React, { useState, useEffect } from 'react';
// import { collection, getDocs } from 'firebase/firestore';
// import { orderDb } from '../firebaseOrders';
// import AdminOrderCard from './AdminOrderCard';

// const cities = [
//   'Seattle, WA', 'Cincinnati, OH', 'Dallas, TX', 'Reno, NV',
//   'Robbinsville, NJ', 'Jacksonville, FL', 'Minneapolis, MN',
//   'Phoenix, AZ', 'Richmond, VA'
// ];

// // ----------------------
// // Fetch inventory for a style/color/size
// // ----------------------
// const fetchInventory = async (style, color, size) => {
//   try {
//     const response = await fetch('https://api-shipping-28612190fdf4.herokuapp.com/inventory', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ style, color, size }),
//     });

//     const text = await response.text();
//     const xml = new DOMParser().parseFromString(text, 'application/xml');

//     // ✅ Get all <listResponse> inside <return>
//     const returnNode = xml.getElementsByTagName('return')[0];
//     const listNodes = returnNode ? returnNode.getElementsByTagName('listResponse') : [];

//     const quantities = Array.from(listNodes).map(node => {
//       const val = node.textContent.trim();
//       return val === '0' ? 'Out of Stock' : val;
//     });

//     // Map to cities
//     const cityQuantities = cities.reduce((acc, city, index) => {
//       acc[city] = quantities[index] || 'No Info';
//       return acc;
//     }, {});

//     return cityQuantities;

//   } catch (err) {
//     console.error('Inventory fetch error:', err);
//     return cities.reduce((acc, city) => {
//       acc[city] = 'No Info';
//       return acc;
//     }, {});
//   }
// };


// // ----------------------
// // AdminOrders Component
// // ----------------------
// const AdminOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [inventoryData, setInventoryData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState('');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');

//   useEffect(() => {
//     const fetchOrders = async () => {
//       const ordersSnapshot = await getDocs(collection(orderDb, 'orders'));
//       const ordersList = ordersSnapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data()
//       }));

//       setOrders(ordersList);

//       // ----------------------
//       // Fetch inventory for all items
//       // ----------------------
//       const inventoryPromises = [];
//       ordersList.forEach(order => {
//         order.items?.forEach(item => {
//           const productId = `${item.style}-${item.colorName4API}-${item.size}`;
//           if (!inventoryPromises.some(p => p.productId === productId)) {
//             inventoryPromises.push(
//               fetchInventory(item.style, item.colorName4API, item.size).then(cityQuantities => ({
//                 productId,
//                 cityQuantities
//               }))
//             );
//           }
//         });
//       });

//       const inventoryResults = await Promise.all(inventoryPromises);
//       const inventoryMap = {};
//       inventoryResults.forEach(({ productId, cityQuantities }) => {
//         inventoryMap[productId] = cityQuantities;
//       });

//       setInventoryData(inventoryMap);
//       setLoading(false);
//     };

//     fetchOrders();
//   }, []);

//   // ----------------------
//   // Filter Orders by Search & Date
//   // ----------------------
//   const filteredOrders = orders.filter(order => {
//     let orderDate = order.createdAt?.toDate ? order.createdAt.toDate() : new Date(order.createdAt);
//     if (!orderDate || isNaN(orderDate)) return false;

//     const from = fromDate ? new Date(fromDate) : null;
//     const to = toDate ? new Date(toDate) : null;
//     if (from) from.setHours(0, 0, 0, 0);
//     if (to) to.setHours(23, 59, 59, 999);

//     const inDateRange = (!from || orderDate >= from) && (!to || orderDate <= to);
//     const name = order.customerDetails?.name?.toLowerCase() || '';
//     const orderNumber = order.orderNumber?.toString() || '';

//     return inDateRange && (name.includes(search.toLowerCase()) || orderNumber.includes(search));
//   });

//   // ----------------------
//   // Totals
//   // ----------------------
//   const getOrderTotal = order =>
//     order.items.reduce((sum, item) => sum + parseFloat(item.price || 0), 0)
//     + parseFloat(order.shippingRate || 0) + 3;

//   const getCost = (order, field) =>
//     order.items.reduce((sum, item) => sum + parseFloat(item[field] || 0), 0);

//   const grandTotal = filteredOrders.reduce((sum, order) => sum + getOrderTotal(order), 0);
//   const garmentTotal = filteredOrders.reduce((sum, order) => sum + getCost(order, 'actualGarmentPrice'), 0);
//   const dtfTotal = filteredOrders.reduce((sum, order) => sum + getCost(order, 'actualImagePrice'), 0);
//   const otherCosts = filteredOrders.reduce((sum, order) => sum + getCost(order, 'otherCost'), 0);
//   const shippingTotal = filteredOrders.reduce((sum, order) => sum + parseFloat(order.shippingRate || 0), 0);

//   const profitLoss = grandTotal - (garmentTotal + dtfTotal + otherCosts + shippingTotal);

//   // ----------------------
//   // Render
//   // ----------------------
 
//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>📦 Admin Orders</h2>

//       <input
//         type="text"
//         placeholder="Search customer or order #..."
//         value={search}
//         onChange={e => setSearch(e.target.value)}
//         style={{ padding: '.5rem', width: '300px' }}
//       />

//       <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
//         <label>From: <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} /></label>
//         <label>To: <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} /></label>
//       </div>

//       <div style={{ marginTop: '2rem', fontWeight: 'bold' }}>
//         <div>Total Sales: ${grandTotal.toFixed(2)}</div>
//         <div>Garments Cost: ${garmentTotal.toFixed(2)}</div>
//         <div>DTF Cost: ${dtfTotal.toFixed(2)}</div>
//         <div>Other Costs: ${otherCosts.toFixed(2)}</div>
//         <div>Profit/Loss: ${profitLoss.toFixed(2)}</div>
//       </div>

//       {loading ? (
//         <p>Loading orders & inventory...</p>
//       ) : (
//         filteredOrders.map(order => (
//           <AdminOrderCard
//             key={order.id}
//             order={order}
//             inventoryData={inventoryData}
//             orderTotal={getOrderTotal(order).toFixed(2)}
//           />
//         ))
//       )}
//     </div>
//   );
// };

// export default AdminOrders;
